module.exports = __webpack_public_path__ + "static/media/tm.27f8ad2d.svg";